// import SimpleImageSlider from "react-simple-image-slider";

import AwesomeSlider from 'react-awesome-slider';
import '../styles.css';

const images1 = [
  { url: "/images/bath/b1.jpg" },
  { url: "/images/bath/b2.jpg" },
  { url: "/images/bath/b3.jpg" },
];

const images2 = [
  { url: "/images/gas/1.jpg" },
  { url: "/images/gas/2.png" },
  { url: "/images/gas/3.jpg" },
  { url: "/images/gas/4.jpg" },
  { url: "/images/gas/5.jpg" },
  { url: "/images/gas/6.jpg" },
  { url: "/images/gas/7.jpg" },
  { url: "/images/gas/8.jpg" },
  { url: "/images/gas/9.jpg" },
  { url: "/images/gas/10.jpg" },
  { url: "/images/gas/11.jpg" },
  { url: "/images/gas/12.jpg" },
  { url: "/images/gas/13.jpg" },
];


const images3 = [
  { url: "/images/kitchens/k1.jpg" },
  { url: "/images/kitchens/k2.jpg" },
  { url: "/images/kitchens/k3.jpg" },
  { url: "/images/kitchens/k4.jpg" },
  { url: "/images/kitchens/w1.jpg" },
  { url: "/images/kitchens/w2.jpg" },
  { url: "/images/kitchens/w3.jpg" },
];


export default function Gallery() {

  let [bathroomsMedia, gasAndBoilersMedia, kitchensMedia] = [[], [], []]
  images1.map((image) => bathroomsMedia.push({source: image.url}))
  images2.map((image) => gasAndBoilersMedia.push({source: image.url}))
  images3.map((image) => kitchensMedia.push({source: image.url}))


  return (
    <div className="page page--gallery">
      <div className="container">

      <section className="page-section page-section--gallery--bathrooms">
          <div className="h2">Gas and Boilers</div>
          <div className="carousel">
            <AwesomeSlider
              media={gasAndBoilersMedia}
            />
          </div>
        </section>

        <section className="page-section page-section--gallery--bathrooms">
          <div className="h2">Bathrooms</div>
          <div className="carousel">
            <AwesomeSlider
              media={bathroomsMedia}
            />
          </div>
        </section>

        <section className="page-section page-section--gallery--bathrooms2">
          <div className="h2">Kitchens and Much more</div>
          <div className="carousel">
            <AwesomeSlider
              media={kitchensMedia}
            />
          </div>
        </section>

        <br></br>

      </div>
    </div>
  )
}
